import React, { useEffect, useState } from "react";
import ReportOptions from "../ReportOptions";
import { Button } from "bootstrap";
import { useNavigate } from "react-router-dom";
import { proxy } from '../../process/api';
import DynamicDTFloat from "../DynamicDTFloat";
import DynamicDTFloatTabs from "../DynamicDTFloatTabs";
import DropDownControl from "../DropDownControl";
import BrandedLoader from "../BrandedLoader";
import { hst03_report_json_format, generateExcel, getHeaderColNames, excelColorCodes, transformNavDataForLabels, goFullScreen } from "../../utils";

import MultiSelectOptions from "./../MultiSelectOptions";
import MultiSheetProcessingLoader from "../MultiSheetProcessingLoader";
import ProcessLoader from "../ProcessLoader";


const BM03 = () => {

    const navigate = useNavigate();

    const div_data = JSON.parse(localStorage.getItem('div_data'));
    const year_data = JSON.parse(localStorage.getItem('year_data'));
    const month_data = JSON.parse(localStorage.getItem('month_data'));
    const depo_data = JSON.parse(localStorage.getItem('depo_data'));
    const seleted_div_value = localStorage.getItem('selected_div');
    const [showOptions, setShowOptions] = useState(true);
    const [reportGenData, setreportGenData] = useState({});
    const [SelectedDiv, setSelectedDIV] = useState(seleted_div_value);
    const [SelectedYear, setSelectedYear] = useState(year_data.data[0].value);
    const [SelectedDepo, setSelectedDepo] = useState(depo_data.data[0].value);
    const [SelectedStartMonth, setSelectedStartMonth] = useState(month_data.data[0].value);
    const [SelectedEndMonth, setSelectedEndMonth] = useState(month_data.data[month_data.index - 1].value);
    const [unitValue, setUnitvalue] = useState(2);
    const [ReportType, setReportType] = useState(1);
    const [ReportOption, setReportOption] = useState(1);
    const [groupLoader, setGroupLoader] = useState(true);
    const [GroupListItems, setGroupListItems] = useState([]);
    const [SelectedGroup, setSelectedGroup] = useState(0);
    const [productReportData, setProductReportdata] = useState([]);
    const [tabLoader, setTabLoader] = useState([]);
    const [sheetloaderMessage, setSheetLoaderMessage] = useState("");
    const [productListItems, setProductListItems] = useState([]);
    const [reportGenerationCompleted, setReportGenerationCompleted] = useState(false);
    const [reportDataReady, setReportDataReady] = useState(false);
    const [MultiSheetDownloadStart, setMultiSheetDownloadStart] = useState(false);
    const [showProcessLoader, setShowProcessLoader] = useState(false);
    const [pageTitle, setPageTitle] = useState('');
    const [productlistLoading, setProductlistLoading] = useState(true);
    const [itemType, setItemType] = useState(1);

    useEffect(() => {

        if (reportGenerationCompleted) {
            setReportDataReady(true);
        }
    }, [reportGenerationCompleted]);

    const loadProductItems = async (division, year) => {
        setProductlistLoading(true);

        const payload = {};
        const dataAPIResponse = await proxy(`/api/mis/productlist/${division}/${year}/0`, payload, "get");
        const converted_list = convertProductData(dataAPIResponse);
        setProductListItems(converted_list);
        setSelectedGroup(0);
        setProductlistLoading(false);

    }

    function convertProductData(dataAPIResponse) {
        if (dataAPIResponse && Array.isArray(dataAPIResponse.data)) {
            const converted_list = dataAPIResponse.data.map(item => ({
                value: item['value'],
                label: item['name']
            }));
            return converted_list;
        }
        return [];
    }


    useEffect(() => {
        if (reportDataReady) {
            var multiReportTitle = [];

            var reportJson = {};
            reportJson.fileName = "10-Selective Product Mnth/Cumm Form 6-" + SelectedYear + ".xlsx";
            reportJson.title = "10-Selective Product Mnth/Cumm Form 6";
            reportJson.author = "Aristo Pharma";

            var decimal_indexes = [];

            reportJson.sheets = [];
            productReportData.map((singlereport, index) => {

                reportJson.sheets.push({
                    name: SelectedGroup[index].value.toString().trim(),
                    data: []
                })
                multiReportTitle.push(singlereport.data.title);

                if (singlereport.data.data.length > 0) {

                    const columns = Object.keys(singlereport.data.data[0]).filter(key => key !== 'color');
                    const headerFormatted = columns.map(key => getHeaderColNames(key));



                    reportJson.sheets[index].data.push({
                        backgroundColor: "#0043a9",
                        fontColor: "#FFFFFF",
                        fontSize: 13,
                        bold: true,
                        values: headerFormatted
                    });

                    const backgroundColors = excelColorCodes;

                    singlereport.data.data.forEach(item => {
                        const row = {
                            backgroundColor: backgroundColors[item.color] || "",
                            fontColor: item.color === 2 ? "#333333" : "#333333",
                            fontSize: 12,
                            bold: false,
                            //  values: columns.map(col => item[col])
                            values: columns.map((col, colIndex) => {
                                let value = item[col];

                                if (Array.isArray(reportGenData.decimal_keys) && reportGenData.decimal_keys.length > 0) {
                                    if (reportGenData.decimal_keys.includes(col)) {
                                        if (!decimal_indexes.includes(colIndex)) {
                                            decimal_indexes.push(colIndex);
                                        }
                                    }
                                }

                                return value;
                            })
                        };
                        reportJson.sheets[index].data.push(row);
                    });

                } else {

                    const columns = ['NoData'];
                    const item = { "NoData": "No Data" }
                    const headerFormatted = ["No Data"];
                    reportJson.sheets[index].data.push({
                        backgroundColor: "#0043a9",
                        fontColor: "#FFFFFF",
                        fontSize: 13,
                        bold: true,
                        values: headerFormatted
                    });
                    const row = {
                        backgroundColor: "",
                        fontColor: "#333333",
                        fontSize: 12,
                        bold: false,
                        //  values: columns.map(col => item[col])
                        values: columns.map((col, colIndex) => {
                            let value = item[col];

                            if (Array.isArray(reportGenData.decimal_keys) && reportGenData.decimal_keys.length > 0) {
                                if (reportGenData.decimal_keys.includes(col)) {
                                    if (!decimal_indexes.includes(colIndex)) {
                                        decimal_indexes.push(colIndex);
                                    }
                                }
                            }

                            return value;
                        })
                    };
                    reportJson.sheets[index].data.push(row);

                }
            });

            generateExcel(reportJson, 40, 20, 0, 3, multiReportTitle, decimal_indexes).catch(console.error);

            setReportDataReady(false);
            setMultiSheetDownloadStart(false);
            setReportGenerationCompleted(false);
        }
    }, [reportDataReady]);




    function getTabreport(pcode) {

        const index = productReportData.findIndex(item => item.product_code === pcode);
        return productReportData[index].data;

    }



    const handleGroupChange = (selectedGroup) => {
        if (selectedGroup.length > 20) {
            alert('Maximum of 20 products can be selected at a time. Please remove extra products.');
        } else {
            setSelectedGroup(selectedGroup);
        }
    }

    const handleProductChange = (selectedGroup) => {
        if (selectedGroup.length > 20) {
            alert('Maximum of 20 products can be selected at a time. Please remove extra products.');
        } else {
            setSelectedGroup(selectedGroup);
        }
    }


    const handleExportSheet = async () => {

        var reportJson = {};
        reportJson.fileName = reportGenData.title + ".xlsx";
        reportJson.title = reportGenData.title;
        reportJson.author = "Aristo Pharma";
        reportJson.sheets = [
            {
                name: "Sheet 1",
                data: []
            }
        ]

        const columns = Object.keys(reportGenData.data[0]).filter(key => key !== 'color');
        const headerFormatted = columns.map(key => getHeaderColNames(key));

        reportJson.sheets[0].data.push({
            backgroundColor: "#0043a9",
            fontColor: "#FFFFFF",
            fontSize: 13,
            bold: true,
            values: headerFormatted
        });

        const backgroundColors = excelColorCodes;

        reportGenData.data.forEach(item => {
            const row = {
                backgroundColor: backgroundColors[item.color] || "", // Default to white if undefined
                fontColor: item.color === 2 ? "#333333" : "#333333",
                fontSize: 12,
                bold: false,
                values: columns.map(col => item[col])
            };
            reportJson.sheets[0].data.push(row);
        });

        generateExcel(reportJson).catch(console.error);

    }

    const handleReportGen = async () => {

        setShowProcessLoader(true);
        console.log(SelectedGroup);

        if (SelectedGroup.length == 0 || SelectedGroup == 0) {
            alert('Select aleast one group');
            return;
        }
        const parsed_vals = SelectedGroup.map(item => item.value).join(",");

        const payload = {
            "myear": parseInt(SelectedYear),
            "div_code": parseInt(SelectedDiv),
            "depo_code": parseInt(SelectedDepo),
            "smon": parseInt(SelectedStartMonth),
            "emon": parseInt(SelectedEndMonth),
            "group_code": parsed_vals,

            "rep_type": ReportType,


        }

        var reportAPIResponse = {};

        if (ReportType == 1) {
            reportAPIResponse = await proxy(`/api/mis/mktrepo2group`, payload, "get");
            setreportGenData(reportAPIResponse);
        } else {
            reportAPIResponse = await proxy(`/api/mis/mktrepo2grouptrend`, payload, "get");

            setreportGenData(hst03_report_json_format(reportAPIResponse));
        }



        setShowProcessLoader(false);
        setShowOptions(false);


        return;
    }


    const handleTabChange = (groupCode) => {
        if (!tabLoader.includes(groupCode)) {
            //  generateProductReport(groupCode);
        } else {

        }
    }

    const generateProductReport = (groupCode) => {

    }

    const handleExportMultiSheet = async () => {

        setMultiSheetDownloadStart(true);
        if (SelectedGroup.length !== productReportData.length) {
            for (let i = 0; i < SelectedGroup.length; i++) {
                setSheetLoaderMessage("Processing data for group #" + SelectedGroup[i].value);
                await generateProductReport(SelectedGroup[i].value);
            }
            setReportGenerationCompleted(true);
        } else {
            setReportGenerationCompleted(true);
        }

    }


    const loadGroupList = async (div, year) => {
        setGroupLoader(true);
        setSelectedGroup({});
        const grouplistAPIResponse = await proxy(`/api/mis/grouplist/${div}/${year}`, {}, "get");
        const converted_list = convertGroupData(grouplistAPIResponse);

        setGroupListItems(converted_list);
        setGroupLoader(false);
        setSelectedGroup(0);

    }


    const handleBranchChange = async (newValue) => {
        setSelectedDepo(newValue);
    }

    function convertGroupData(dataAPIResponse) {
        if (dataAPIResponse && Array.isArray(dataAPIResponse.data)) {
            const converted_list = dataAPIResponse.data.map(item => ({
                value: item['value'],
                label: item['name']
            }));
            return converted_list;
        }
        return [];
    }

    const handleYearChange = async (newYear) => {

        setSelectedYear(newYear);
        loadGroupList(SelectedDiv, newYear);
    }

    useEffect(() => {
        //  loadProductItems(SelectedDiv, SelectedYear);
        loadGroupList(SelectedDiv, SelectedYear);
        transformNavDataForLabels("BM03").then(title => {
            setPageTitle(title);
        });


    }, []);

    return (
        <>
            <div class="main-content">
                {showProcessLoader && <ProcessLoader />}
                {showOptions ?
                    <ReportOptions title={pageTitle} >
                        <div className="report-option-wrapper">
                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <label>Division</label>
                                    <DropDownControl selectedValue={SelectedDiv} data={div_data.data} id="report_div_list" name="report_div_list" onChange={(newVal) => { setSelectedDIV(newVal); loadGroupList(newVal, SelectedYear); }} />
                                </div>

                                <div className="report-option-item ml-20">
                                    <label>Branch</label>
                                    <DropDownControl data={depo_data.data} id="report_branch_list" name="report_branch_list"

                                        onChange={(newBranch) => { handleBranchChange(newBranch); }}
                                    />
                                </div>

                            </div>

                            <div className="report-option-row">
                                <div className="report-option-item ">
                                    <label>Mkt&nbsp;Year</label>
                                    <DropDownControl data={year_data.data} id="report_mktyear_list" name="report_mktyear_list" onChange={(newYear) => { handleYearChange(newYear) }} />

                                </div>

                                <div className="report-option-item ml-10">
                                    <label>From</label>
                                    <DropDownControl data={month_data.data} id="report_startyear_list" name="report_startyear_list" selectedValue={SelectedStartMonth} onChange={(val) => { console.log(val); setSelectedStartMonth(val) }} />
                                </div>
                                <div className="report-option-item ml-10">
                                    <label>To</label>
                                    <DropDownControl data={month_data.data} id="report_endyear_list" name="report_endyear_list" selectedValue={SelectedEndMonth} onChange={(val) => { console.log(val); setSelectedEndMonth(val) }} />
                                </div>

                            </div>


                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <input type="radio" class="js-switched mr-10" name="report_rptype" checked={(true && ReportType === 1)}
                                        onChange={(e) => { setReportType(1);; }} />
                                    <label>Mnth/Cumm</label>
                                </div>
                                <div className="report-option-item ml-14">
                                    <input type="radio" class="js-switched mr-10" name="report_rptype" checked={(true && ReportType === 2)}
                                        onChange={(e) => { setReportType(2);; }} />
                                    <label>Sales Trend</label>
                                </div>


                            </div>








                            {itemType == 2 &&
                                <div className="report-option-row">
                                    <div className="report-option-item">
                                        <label >Select&nbsp;Product</label>
                                        {productlistLoading ? <BrandedLoader /> :
                                            <MultiSelectOptions
                                                itemsData={productListItems}
                                                onChange={handleGroupChange}
                                            />}

                                    </div>
                                </div>
                            }
                            {itemType == 1 &&
                                <div className="report-option-row">
                                    <div className="report-option-item">
                                        <label >Select&nbsp;Group</label>
                                        {groupLoader ? <BrandedLoader /> :
                                            <MultiSelectOptions
                                                itemsData={GroupListItems}
                                                onChange={handleGroupChange}
                                            />}

                                    </div>
                                </div>
                            }













                            <div className="report-option-action-row">
                                <button onClick={(e) => { navigate('/dashboard'); }} className="btn btn-outline btn-md btn-sec mr-10 fw-500">BACK</button>
                                <button onClick={handleReportGen} className="btn btn-md btn-primary pr-30 pl-30 fw-500 " id="btnReportGen" >SUBMIT</button>
                            </div>
                        </div>
                    </ReportOptions>
                    :
                    <>
                        <div className="row">
                            <div className="col-12">
                                <div className="card report-card" style={{ width: "auto" }}>
                                    <div className="card-title report-card-title">{reportGenData.title}
                                        <button className="btn btn-outline btn-md  mr-10 fw-500" onClick={(e) => { window.location.reload() }}>BACK</button>
                                    </div>
                                    <div className="card-body">
                                        <DynamicDTFloat
                                            tableData={reportGenData}

                                            handleExportSheet={handleExportSheet}
                                            firstColWidth="200px"
                                            secColWidth="100px"
                                            fixedColumns={true}
                                            forceDecimal={reportGenData.decimal_keys?.length > 0}
                                            decimalKeys={reportGenData.decimal_keys}
                                        />

                                    </div>

                                </div>
                            </div>
                        </div>
                    </>

                }
                {MultiSheetDownloadStart && <MultiSheetProcessingLoader title="Please wait while we download the excel file." loadingText={sheetloaderMessage} />}

            </div>
        </>
    );


}

export default BM03;